import dateFormat from 'dateformat';
import setHeaderRender from "../../../components/app/setHeaderRender.js";

const setColumns = ({ modalDetail, allowWrite, changeDelay, objFilter }) => {

    return [
        {
            id: "checkbox",
            visible: false,
            pinned: false,
            width: "54px",
        },
        {
            id: "code",
            field: "code",
            label: "code",
            width: '100px',
            sortable: false,
            resizable: true,
            //headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'code', changeDelay, tableManager, column}) )
        },
        {
            id: "2",
            field: "user_id.email",
            label: "Email",
            sortable: false,
            resizable: true,
            //headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Email', changeDelay, tableManager, column}) )
            cellRenderer: ({ data }) => (data.user_id ? data.user_id.email : '')
        },
        {
            id: "3",
            field: "username",
            label: "Username",
            width: '250px',
            sortable: false,
            headerCellRenderer: ({ tableManager, column }) => (<>
                <table><tbody>
                    <tr><td>UserName</td></tr>
                    <tr><td><input id="UserName" defaultValue={ objFilter['username'] ? objFilter['username'].replace(/^\*+|\*+$/g, '') : '' } name="UserName" type="text" style={{ height: 20 }} onChange={e => changeDelay( e.target.value ? ('*' + e.target.value + '*') : '', tableManager, column)} /></td></tr>
                </tbody></table>  </>)
        },
        {
            id: "4",
            field: "user_id.code",
            label: "UserCode",
            width: '180px',
            sortable: false,
            //headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Path (Domain)', changeDelay, tableManager, column}) )
            cellRenderer: ({ data }) => (data.user_id ? data.user_id.code : '' )
        },
        {
            id: "5",
            field: "user_id.segCveAgenteId",
            label: "segCveAgenteId",
            width: '180px',
            sortable: false,
            //headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Path (Domain)', changeDelay, tableManager, column}) )
            cellRenderer: ({ data }) => (data.user_id ? data.user_id.segCveAgenteId : '' )
        },
        {
            id: "6",
            field: "createdAt",
            label: "Date",
            sortable: false,
            cellRenderer: ({ data }) => (data.createdAt
                ? dateFormat(new Date(data.createdAt), "dd/mm/yyyy", true)
                : dateFormat(new Date(), "dd/mm/yyyy", true))
        },
        {
            id: "7",
            field: "count",
            label: "count",
            sortable: false,
            //headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'ProviderType', changeDelay, tableManager, column}) )
        }

    ];
};

export default setColumns;
